export const environment = {
    production: false,
    apiUrl: 'https://api-vce-dev.ogenkisoftlab.com', 
    recaptchaSiteKey: '6LdOwg0qAAAAAMfvENo52Wdv7D37KVM5-y4rJYnA',
    apiKey: 'cB1VufAk4c4VREVBaaN9B6Lvd5J7OQLw6c2dRVYt',
    noAccountId: 2,
    imageAnswerFilePath: "https://vce-exam-dev.s3.ap-southeast-1.amazonaws.com"
  };
  